import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { logSuccess, logError } from '../toaster'

export const toggleSensitiveDataPolicyMutation = gql`
  mutation ToggleSensitiveDataPolicy(
    $organizationID: ID!
    $policyID: ID!
    $enabled: Boolean!
  ) {
    toggleSensitiveDataPolicy(
      input: {
        organizationID: $organizationID
        policyID: $policyID
        enabled: $enabled
      }
    ) {
      _placeholder
    }
  }
`

export interface ToggleSensitiveDataPolicyArgs {
  readonly organizationID: string
  readonly policyID: string
  readonly enabled: boolean
}

export function ToggleSensitiveDataPolicyMutation({
  children
}: {
  readonly children: (
    updateSensitiveDataPolicy: (
      variables: ToggleSensitiveDataPolicyArgs,
      successMessage: string,
      errorMessage: string
    ) => Promise<any>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, ToggleSensitiveDataPolicyArgs>
      mutation={toggleSensitiveDataPolicyMutation}
    >
      {(toggleSensitiveDataPolicy) => {
        return children(
          async (
            variables: ToggleSensitiveDataPolicyArgs,
            successMessage,
            errorMessage
          ) => {
            try {
              await toggleSensitiveDataPolicy({
                variables
              })
              logSuccess(successMessage)
            } catch (_) {
              logError(errorMessage)
            }
          }
        )
      }}
    </Mutation>
  )
}
